import React, { useState, useContext } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import AboutSection from "../components/about-section"
import AboutNav from "../components/about-nav"
import useRedirectToLang from "../hooks/useRedirectToLang"
import { WidthContext } from "../contexts/width-context"
import { ViewportContext } from "../contexts/viewport-context"
import Navigation from "../components/navigation"

const UberPage = () => {
  useRedirectToLang("/about")
  const [pageNavigationState, setPageNavigationState] = useState("we")
  const width = useContext(WidthContext)
  const dimensions = useContext(ViewportContext)

  const pageNavigation = ["we", "philosophy", "locations", "team", "csr"]

  const handleButtonClick = index => {
    if (pageNavigation[index] !== pageNavigationState) {
      setPageNavigationState(pageNavigation[index])
      if (window.innerWidth < 641) {
        window.scrollTo(0, 0)
      }
    }
  }

  return (
    <>
      <SEO title="Über" />
      <Layout path="/about" width={dimensions[0]}>
        <AboutNav
          navState={pageNavigationState}
          buttonClick={handleButtonClick}
          width={width}
        />
        <AboutSection navState={pageNavigationState} dimensions={dimensions} />
      </Layout>
      <Navigation path="/about" width={dimensions[0]} />
    </>
  )
}

export default UberPage
